@if (isVisible) {
  <div [class]="calloutClasses" role="alert">
    <div class="pgo-callout-content">
      <div class="pgo-callout-body">
        @if (title) {
          <div class="pgo-callout-title">{{ title }}</div>
        }
        <div class="pgo-callout-message">
          <ng-content></ng-content>
        </div>
      </div>
      @if (dismissible) {
        <button
          type="button"
          class="pgo-callout-dismiss"
          (click)="onDismiss()"
          aria-label="Close">
          <i class="far fa-times"></i>
        </button>
      }
    </div>
  </div>
}
